import { StoreItemModel } from './store-item-model';
import { Serializable } from '../../../core/models/serializable';

export class SliderBannerModel implements Serializable<SliderBannerModel> {
  fromObject(object: any): SliderBannerModel {
    Object.assign(this, object);

    if (object.storeItem != null) {
      let s = new StoreItemModel();

      this.storeItem = s.fromObject(object.storeItem);
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public sliderBannerId: number;
  public customerId: number;
  public requestCustomerAgentId: number;
  public processUserId: number;

  public createDate: Date;
  public processDate: Date;
  public expireDate: Date;
  public cancelDate: Date;

  public sliderBannerStatusId: number;
  public dayCount: number;
  public providerWebsiteId: number;

  public customerName: String;

  public storeItem: StoreItemModel;
  public storeItemId: number; // binds to item select tag

  public portfolioId: number;
  public portfolioName: string;
  public portfolioAccountManagerName: string;
}
